import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Analytics } from "@/components/Analytics";
import Landing from "@/pages/Landing";
import InsightsList from "@/pages/InsightsList";
import ArticleDetail from "@/pages/ArticleDetail";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import MarketPage from "@/pages/MarketPage";
import ServicePage from "@/pages/ServicePage";
import BookConsultation from "@/pages/BookConsultation";

const SERVICE_SLUGS = [
  "employee-relations-advisory", "sensitive-case-advisory", "workplace-investigations",
  "people-risk-advisory", "er-capability-diagnostic", "employee-relations-framework", "fractional-er-partner",
];

function App() {
  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <AuthProvider>
          <BrowserRouter>
            <Analytics />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/insights" element={<InsightsList />} />
              <Route path="/insights/:slug" element={<ArticleDetail />} />
              <Route path="/book-consultation" element={<BookConsultation />} />
              {SERVICE_SLUGS.map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<ServicePage />} />
              ))}
              <Route path="/markets/:slug" element={<MarketPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
